// extracted by mini-css-extract-plugin
export var icon = "tick_list_item-module--icon--z7MDd";
export var isDisabled = "tick_list_item-module--isDisabled---3m6r";
export var tickListItem = "tick_list_item-module--tickListItem--UM8qD";